// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { AccountsDestroyData, AccountsDestroyResponses, ArtworksCreateLogoArtworkCreateData, ArtworksCreateLogoArtworkCreateResponses, ArtworksCreatePhotoArtworkCreateData, ArtworksCreatePhotoArtworkCreateResponses, ArtworksDestroyData, ArtworksDestroyResponses, ArtworksListData, ArtworksListResponses, ArtworksPrintTemplateRetrieveData, ArtworksPrintTemplateRetrieveErrors, ArtworksPrintTemplateRetrieveResponses, ArtworksRetrieveData, ArtworksRetrieveResponses, AuthEmailLoginCreateData, AuthEmailLoginCreateResponses, AuthGuestLoginCreateData, AuthGuestLoginCreateResponses, AuthObtainJwtFromEmailCodeCreateData, AuthObtainJwtFromEmailCodeCreateResponses, AuthObtainJwtFromEmailTokenCreateData, AuthObtainJwtFromEmailTokenCreateResponses, AuthRetrieveData, AuthRetrieveResponses, AuthStaffEmailLoginCreateData, AuthStaffEmailLoginCreateResponses, AuthTokenRefreshCreateData, AuthTokenRefreshCreateResponses, AuthTokenVerifyCreateData, AuthTokenVerifyCreateResponses, OrdersCancelCreateData, OrdersCancelCreateErrors, OrdersCancelCreateResponses, OrdersCompleteCreateData, OrdersCompleteCreateErrors, OrdersCompleteCreateResponses, OrdersCreateData, OrdersCreateResponses, OrdersListData, OrdersListResponses, OrdersPrintTemplateRetrieveData, OrdersPrintTemplateRetrieveErrors, OrdersPrintTemplateRetrieveResponses, OrdersRetrieveData, OrdersRetrieveResponses, SseRetrieve2Data, SseRetrieve2Responses, SseRetrieveData, SseRetrieveResponses, VenuesDecorationsRetrieveData, VenuesDecorationsRetrieveResponses, VenuesListData, VenuesListResponses, VenuesRetrieveData, VenuesRetrieveResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export const accountsDestroy = <ThrowOnError extends boolean = false>(options: Options<AccountsDestroyData, ThrowOnError>) => (options.client ?? client).delete<AccountsDestroyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/accounts/{id}/',
    ...options
});

export const artworksList = <ThrowOnError extends boolean = false>(options?: Options<ArtworksListData, ThrowOnError>) => (options?.client ?? client).get<ArtworksListResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/artworks/',
    ...options
});

export const artworksDestroy = <ThrowOnError extends boolean = false>(options: Options<ArtworksDestroyData, ThrowOnError>) => (options.client ?? client).delete<ArtworksDestroyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/artworks/{id}/',
    ...options
});

export const artworksRetrieve = <ThrowOnError extends boolean = false>(options: Options<ArtworksRetrieveData, ThrowOnError>) => (options.client ?? client).get<ArtworksRetrieveResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/artworks/{id}/',
    ...options
});

export const artworksPrintTemplateRetrieve = <ThrowOnError extends boolean = false>(options: Options<ArtworksPrintTemplateRetrieveData, ThrowOnError>) => (options.client ?? client).get<ArtworksPrintTemplateRetrieveResponses, ArtworksPrintTemplateRetrieveErrors, ThrowOnError>({
    responseType: 'blob',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/artworks/{id}/print-template/',
    ...options
});

export const artworksCreateLogoArtworkCreate = <ThrowOnError extends boolean = false>(options: Options<ArtworksCreateLogoArtworkCreateData, ThrowOnError>) => (options.client ?? client).post<ArtworksCreateLogoArtworkCreateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/artworks/create-logo-artwork/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const artworksCreatePhotoArtworkCreate = <ThrowOnError extends boolean = false>(options: Options<ArtworksCreatePhotoArtworkCreateData, ThrowOnError>) => (options.client ?? client).post<ArtworksCreatePhotoArtworkCreateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/artworks/create-photo-artwork/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const authRetrieve = <ThrowOnError extends boolean = false>(options: Options<AuthRetrieveData, ThrowOnError>) => (options.client ?? client).get<AuthRetrieveResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/{id}/',
    ...options
});

/**
 * This sends an email with a 6-digit token we can trade for a user's JWT Token.
 */
export const authEmailLoginCreate = <ThrowOnError extends boolean = false>(options: Options<AuthEmailLoginCreateData, ThrowOnError>) => (options.client ?? client).post<AuthEmailLoginCreateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/email_login/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * This is a special login endpoint for guests.
 */
export const authGuestLoginCreate = <ThrowOnError extends boolean = false>(options: Options<AuthGuestLoginCreateData, ThrowOnError>) => (options.client ?? client).post<AuthGuestLoginCreateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/guest_login/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Takes an email plus auth_code and returns an access and refresh JWT
 * pair to prove the authentication of those credentials.
 */
export const authObtainJwtFromEmailCodeCreate = <ThrowOnError extends boolean = false>(options: Options<AuthObtainJwtFromEmailCodeCreateData, ThrowOnError>) => (options.client ?? client).post<AuthObtainJwtFromEmailCodeCreateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/obtain_jwt_from_email_code/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Takes an email plus auth_token and returns an access and refresh JWT
 * pair to prove the authentication of those credentials.
 */
export const authObtainJwtFromEmailTokenCreate = <ThrowOnError extends boolean = false>(options: Options<AuthObtainJwtFromEmailTokenCreateData, ThrowOnError>) => (options.client ?? client).post<AuthObtainJwtFromEmailTokenCreateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/obtain_jwt_from_email_token/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * This sends a staff user an email with a 6-digit code to trade for a JWT.
 */
export const authStaffEmailLoginCreate = <ThrowOnError extends boolean = false>(options: Options<AuthStaffEmailLoginCreateData, ThrowOnError>) => (options.client ?? client).post<AuthStaffEmailLoginCreateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/staff_email_login/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Takes a refresh type JSON web token and returns an access type JSON web
 * token if the refresh token is valid.
 */
export const authTokenRefreshCreate = <ThrowOnError extends boolean = false>(options: Options<AuthTokenRefreshCreateData, ThrowOnError>) => (options.client ?? client).post<AuthTokenRefreshCreateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/token/refresh/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Takes a token and indicates if it is valid.  This view provides no
 * information about a token's fitness for a particular use.
 */
export const authTokenVerifyCreate = <ThrowOnError extends boolean = false>(options: Options<AuthTokenVerifyCreateData, ThrowOnError>) => (options.client ?? client).post<AuthTokenVerifyCreateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/token/verify/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const ordersList = <ThrowOnError extends boolean = false>(options?: Options<OrdersListData, ThrowOnError>) => (options?.client ?? client).get<OrdersListResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/orders/',
    ...options
});

export const ordersCreate = <ThrowOnError extends boolean = false>(options: Options<OrdersCreateData, ThrowOnError>) => (options.client ?? client).post<OrdersCreateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/orders/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const ordersRetrieve = <ThrowOnError extends boolean = false>(options: Options<OrdersRetrieveData, ThrowOnError>) => (options.client ?? client).get<OrdersRetrieveResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/orders/{identifier}/',
    ...options
});

export const ordersCancelCreate = <ThrowOnError extends boolean = false>(options: Options<OrdersCancelCreateData, ThrowOnError>) => (options.client ?? client).post<OrdersCancelCreateResponses, OrdersCancelCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/orders/{identifier}/cancel/',
    ...options
});

export const ordersCompleteCreate = <ThrowOnError extends boolean = false>(options: Options<OrdersCompleteCreateData, ThrowOnError>) => (options.client ?? client).post<OrdersCompleteCreateResponses, OrdersCompleteCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/orders/{identifier}/complete/',
    ...options
});

export const ordersPrintTemplateRetrieve = <ThrowOnError extends boolean = false>(options: Options<OrdersPrintTemplateRetrieveData, ThrowOnError>) => (options.client ?? client).get<OrdersPrintTemplateRetrieveResponses, OrdersPrintTemplateRetrieveErrors, ThrowOnError>({
    responseType: 'blob',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/orders/{identifier}/print-template/',
    ...options
});

/**
 * A viewset to stream events to the client. Here you will be able to see the events in real time.
 *
 * By default, this viewset will not stream any events, because you must configure the channels you want to see the events from.
 * To configure the channels, you can do it in three ways:
 * - By setting the channels attribute in the class definition.
 * - By setting the channels query parameter in the request.
 * - By setting the channel in the URL.
 * Those three ways are mutually exclusive, so you can only use one of them.
 *
 * If you want to see a specific type of messages and not the default "message" type, you can set the messages_types attribute in the class definition or by using the configure_events_view_set method.
 * That's the only ways provided to set the messages types.
 */
export const sseRetrieve = <ThrowOnError extends boolean = false>(options?: Options<SseRetrieveData, ThrowOnError>) => (options?.client ?? client).get<SseRetrieveResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/sse/',
    ...options
});

/**
 * A viewset to stream events to the client. Here you will be able to see the events in real time.
 *
 * By default, this viewset will not stream any events, because you must configure the channels you want to see the events from.
 * To configure the channels, you can do it in three ways:
 * - By setting the channels attribute in the class definition.
 * - By setting the channels query parameter in the request.
 * - By setting the channel in the URL.
 * Those three ways are mutually exclusive, so you can only use one of them.
 *
 * If you want to see a specific type of messages and not the default "message" type, you can set the messages_types attribute in the class definition or by using the configure_events_view_set method.
 * That's the only ways provided to set the messages types.
 */
export const sseRetrieve2 = <ThrowOnError extends boolean = false>(options: Options<SseRetrieve2Data, ThrowOnError>) => (options.client ?? client).get<SseRetrieve2Responses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/sse/{channel}/',
    ...options
});

export const venuesList = <ThrowOnError extends boolean = false>(options?: Options<VenuesListData, ThrowOnError>) => (options?.client ?? client).get<VenuesListResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/venues/',
    ...options
});

export const venuesRetrieve = <ThrowOnError extends boolean = false>(options: Options<VenuesRetrieveData, ThrowOnError>) => (options.client ?? client).get<VenuesRetrieveResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/venues/{identifier}/',
    ...options
});

export const venuesDecorationsRetrieve = <ThrowOnError extends boolean = false>(options: Options<VenuesDecorationsRetrieveData, ThrowOnError>) => (options.client ?? client).get<VenuesDecorationsRetrieveResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/venues/{identifier}/decorations/',
    ...options
});
